<template>
  <div class="ax-cell-box">
    <list-item>
      <template slot="left">费用报销</template>
      <template slot="content">
        <h6>{{ axDate.employee_name }}的{{ axDate.document_type }}</h6>
        <p>
          {{ axDate.submit_date }}
          <span :class="statusClass[axDate.report_status].className">{{
            statusClass[axDate.report_status].name
          }}</span>
        </p>
      </template>
    </list-item>
  </div>
</template>

<script>
import Vue from 'vue';
import ListItem from '@/components/common/ListItem.vue';
Vue.component('list-item', ListItem);
export default {
  name: 'ax-cell',
  props: {
    axDate: [Object],
  },
  data() {
    return {
      statusClass: {
        审批完成: {
          name: '通过',
          className: 'status-pass',
        },
        审批中: {
          name: '审批中',
          className: 'status-ing',
        },
        新建: {
          name: '审批中',
          className: 'status-ing',
        },
        拒绝: {
          name: '拒绝',
          className: 'status-reject',
        },
        收回: {
          name: '收回',
          className: 'status-reject',
        },
      },
    };
  },
};
</script>
